import {
    Checkbox,
    Chip,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import UploadFileItem from "components/Input/UploadFile";
import React, { useContext, useMemo, useRef, useState } from "react";
import { ProviderAccPayment } from "../../AccountingPayment/AccountingPaymentForm";
import { Extension, FnDialog, I18n } from "utilities/utilities";
import TableTotal from "./TableTotal";
import CustomTablePagination from "../CustomTablePagination";
import { FormProvider, useForm } from "react-hook-form";
import { TextAreaItem } from "components/Input/TextArea";
import InputNumberItem from "components/Input/InputNumber";
import { BtnAdd, BtnCancel, BtnEdit, BtnEditTable } from "components/Button/ButtonAll";
import { TextBoxItem } from "components/Input/TextBox";
import _ from "lodash";
import moment from "moment";
import { numberFormatterLocale, parseFloatCheckValue, renderCellFileCustomTable } from "../../fnTickit";
import RenderCellFile from "../RenderCellFile";
import { I18NextNs } from "enum/enum";

const TablePaymentAdd = ({ isRent }) => {
    const {
        isView,
        objValue,
        setObjValue
    } = useContext(ProviderAccPayment);

    const DialogFn = FnDialog();

    const onClearAttachRentFile = useRef(null);
    const onClearAttachDonateFile = useRef(null);

    const dataTable = useMemo(() => {
        let lst = [];
        if (objValue.lstRent.length > 0 && isRent) {
            lst = objValue.lstRent;
        }
        else if (objValue.lstDonate.length > 0 && !isRent) {
            lst = objValue.lstDonate;
        }
        return lst;
    }, [isRent, objValue.lstDonate, objValue.lstRent])

    const sTitle = useMemo(() => {
        return isRent ? "รายการค่าเช่า" : "เงินบริจาค";
    }, [isRent])

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selected, setSelected] = useState<readonly number[]>([]);
    const [arrAttachment, setArrAttachment] = useState([])
    const [idEdit, setIdEdit] = useState(0)
    const [isOpenFile, setisOpenFile] = useState(false)
    const [arrFile, setarrFile] = useState([])

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            sIncomeItem: null,
            dReceive: null,
            nTotal: null,
            sDescription: null,
        }
    });
    // #endregion


    const isSelected = (id: number) => selected.indexOf(id) !== -1;

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = dataTable.map((n) => n.nID);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (id: number) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected: readonly number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleAdd = () => {
        if (arrAttachment.length === 0) {
            DialogFn.Warning("กรุณาระบุใบเสร็จรับเงิน")
            return;
        }

        let lstDataNew = [];
        let deepCopy = _.cloneDeep(isRent ? objValue.lstRent : objValue.lstDonate);
        let sFileLink = null;
        let sFileName = null;

        if (arrAttachment.length > 0) {
            let objFile = arrAttachment[0];
            sFileLink = objFile.sCropFileLink ?? ""
            sFileName = objFile.sFileName ?? ""
        }

        if (idEdit !== 0) {
            //update Data
            let indEdit = deepCopy.findIndex(f => f.nID === idEdit);
            deepCopy[indEdit].sIncomeItem = form.getValues("sIncomeItem");
            deepCopy[indEdit].dReceive = form.getValues("dReceive").valueOf();
            deepCopy[indEdit].nTotal = form.getValues("nTotal");
            deepCopy[indEdit].sDescription = form.getValues("sDescription");
            deepCopy[indEdit].lstFile = arrAttachment;
            deepCopy[indEdit].sFileLink = sFileLink;
            deepCopy[indEdit].sFileName = sFileName;
            lstDataNew = deepCopy;
        }
        else {
            let nIdMax = deepCopy.length > 0 ? Math.max(...deepCopy.map(itm => { return parseInt(itm.nID) })) + 1 : 1;
            let nOrderMax = deepCopy.length > 0 ? Math.max(...deepCopy.map(itm => { return parseInt(itm.nOrder) })) + 1 : 1;

            let objNew = [{
                nID: nIdMax,
                nOrder: nOrderMax,
                isNew: true,
                isDelete: true,
                sIncomeItem: form.getValues("sIncomeItem"),
                dReceive: form.getValues("dReceive").valueOf(),
                nTotal: form.getValues("nTotal"),
                sDescription: form.getValues("sDescription"),
                lstFile: arrAttachment,
                sFileLink: sFileLink,
                sFileName: sFileName,
            }];
            lstDataNew = [...deepCopy, ...objNew];
        }

        onCalculateTotal(lstDataNew)
        if (isRent) {
            setObjValue(value => {
                return ({
                    ...value,
                    lstRent: lstDataNew
                })
            })
        }
        else {
            setObjValue(value => {
                return ({
                    ...value,
                    lstDonate: lstDataNew
                })
            })
        }

        handleClearInput();
    }

    const handleEdit = (row) => {
        setArrAttachment(row.lstFile)
        setIdEdit(row.nID)
        form.reset({
            sIncomeItem: row.sIncomeItem,
            dReceive: moment(row.dReceive),
            nTotal: row.nTotal,
            sDescription: row.sDescription,
        })
    }

    const handleClearInput = () => {
        setIdEdit(0)
        setArrAttachment([])
        if (isRent) {
            onClearAttachRentFile.current(null);
        }
        else {
            onClearAttachDonateFile.current(null);

        }
        form.clearErrors()
        form.reset({
            sIncomeItem: null,
            dReceive: null,
            nTotal: null,
            sDescription: null,
        })
    }

    const handleDelete = () => {
        if (idEdit !== 0) {
            DialogFn.Warning("ไม่สามารถดำเนินการได้ เนื่องจากมีรายการกำลังดำเนินการแก้ไข")
            return;
        }
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.CloseSubmit();
            let lstNotDelete = dataTable.filter(item => !selected.includes(item.nID));
            if (isRent) {
                setObjValue(value => {
                    return ({
                        ...value,
                        lstRent: lstNotDelete
                    })
                })
            }
            else {
                setObjValue(value => {
                    return ({
                        ...value,
                        lstDonate: lstNotDelete
                    })
                })
            }
            onCalculateTotal(lstNotDelete)
            setSelected([])
        });


    }

    const onCalculateTotal = (lstData) => {

        let sumTotal = _.sumBy(lstData, function (o: any) { return parseFloatCheckValue(o.nTotal); });
        if (isRent) {
            setObjValue(value => {
                return ({
                    ...value,
                    nAmountRent: sumTotal
                })
            })
        }
        else {
            setObjValue(value => {
                return ({
                    ...value,
                    nAmountDonate: sumTotal
                })
            })
        }
    }

    const handleClickFile = (row) => {
        setarrFile([{ sFileLink: row.sFileLink, sFileName: row.sFileName }])
        setisOpenFile(true)
    };

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Divider textAlign="left"><Chip className='ticket-chip font-weight-500' label={sTitle} /></Divider>
                </Grid>
                {isView ? null : <Grid item xs={12}>
                    <FormProvider {...form}>
                        <Grid container spacing={2} alignItems={"flex-start"}>
                            <Grid item xs={12}>
                                <TextBoxItem
                                    name={"sIncomeItem"}
                                    id={"sIncomeItem"}
                                    label={"ชื่อรายการ"}
                                    maxLength={250}
                                    type={"text"}
                                    required={true}
                                    IsShrink={false}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <DatePickerItem
                                    name={"dReceive"}
                                    id={"dReceive"}
                                    label={`วันที่ได้รับเงิน`}
                                    IsDisablePortal
                                    fullWidth={true}
                                    required={true}
                                    maxDate={moment()}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <InputNumberItem
                                    id={`nTotal`}
                                    name={`nTotal`}
                                    label="จำนวนเงิน (บาท)"
                                    required={true}
                                    IsCanMinus={false}
                                    min={0}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextAreaItem
                                    id='sDescription'
                                    name='sDescription'
                                    required={false}
                                    label={"คำอธิบายเพิ่มเติม"}
                                    maxLength={500}
                                    placeholder={"คำอธิบายเพิ่มเติม"}
                                    row={3}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {
                                    isRent ?
                                        <UploadFileItem
                                            id="file-rent"
                                            name={"file-rent"}
                                            key={"file-rent"}
                                            label="ใบเสร็จรับเงิน"
                                            arrFile={arrAttachment}
                                            setarrFile={setArrAttachment}
                                            IsFolder={false}
                                            IsMultiple={false}
                                            Extension={Extension.FileTicket}
                                            nLimitFile={30}
                                            sLimitFile={"MB"}
                                            onClearFile={onClearAttachRentFile}
                                            modeDisplay={"list"}
                                            sFolderTemp={"PaymentRent"}
                                            sPositionText={"right"}
                                            required={true}
                                        />
                                        :
                                        <UploadFileItem
                                            id="file-donate"
                                            name={"file-donate"}
                                            key={"file-donate"}
                                            label="ใบเสร็จรับเงิน"
                                            arrFile={arrAttachment}
                                            setarrFile={setArrAttachment}
                                            IsFolder={false}
                                            IsMultiple={false}
                                            Extension={Extension.FileTicket}
                                            nLimitFile={30}
                                            sLimitFile={"MB"}
                                            onClearFile={onClearAttachDonateFile}
                                            modeDisplay={"list"}
                                            sFolderTemp={"PaymentDonate"}
                                            sPositionText={"right"}
                                            required={true}
                                        />
                                }

                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2} justifyContent={"center"}>
                                    <Grid item>
                                        {
                                            idEdit !== 0 ?
                                                <BtnEdit id="btnedit-rent" onClick={form.handleSubmit(handleAdd)} />
                                                :
                                                <BtnAdd id="btnAdd-rent" txt="เพิ่มรายการรับเงิน" onClick={form.handleSubmit(handleAdd)} />
                                        }
                                    </Grid>
                                    <Grid item>
                                        <BtnCancel id="btncancel-rent" onClick={handleClearInput} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Grid>}
                <Grid item xs={12}>
                    <TableContainer id="table-receive" component={Paper}>
                        <Table sx={{ minWidth: 800 }}>
                            <TableHead>
                                <TableRow>
                                    {isView ? null : <TableCell
                                        className="td-center"
                                        padding="checkbox"
                                        style={{ minWidth: "60px", width: "60px" }}
                                    >
                                        <Checkbox
                                            color="primary"
                                            indeterminate={selected.length > 0 && selected.length < dataTable.length}
                                            checked={dataTable.length > 0 && selected.length === dataTable.length}
                                            disabled={isView}
                                            onChange={handleSelectAllClick}
                                            inputProps={{
                                                "aria-label": "select all",
                                            }}
                                        />
                                    </TableCell>}
                                    {isView ? null : <TableCell
                                        align="center"
                                        style={{ minWidth: "100px", width: "100px" }}
                                    ></TableCell>}
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "180px", width: "180px" }}
                                    >
                                        วันที่รับเงิน
                                    </TableCell>
                                    <TableCell align="center">ชื่อรายการ</TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "180px", width: "180px" }}
                                    >
                                        จำนวนเงิน (บาท)
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ minWidth: "130px", width: "130px" }}
                                    >
                                        ใบเสร็จรับเงิน
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            {dataTable.length > 0 ? (
                                <TableBody>
                                    {dataTable
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            let nNo = page * rowsPerPage + (index + 1);
                                            const isItemSelected = isSelected(row.nID);

                                            return (
                                                <TableRow key={nNo}>
                                                    {isView ? null : <TableCell padding="checkbox">
                                                        <Checkbox
                                                            color="primary"
                                                            checked={isItemSelected}
                                                            disabled={isView}
                                                            onClick={() => handleClick(row.nID)}
                                                            inputProps={{
                                                                "aria-labelledby": `aria-${nNo}`,
                                                            }}
                                                        />
                                                    </TableCell>}
                                                    {isView ? null : <TableCell align="center">
                                                        <BtnEditTable
                                                            id={`btnedit-${nNo}`}
                                                            onClick={() => handleEdit(row)}
                                                            IsCircleWithOutText
                                                        />
                                                    </TableCell>}
                                                    <TableCell align="center">{moment(row.dReceive).add(543, "years").format("DD/MM/YYYY")} </TableCell>
                                                    <TableCell align="left">{row.sIncomeItem}</TableCell>
                                                    <TableCell align="right">{numberFormatterLocale(row.nTotal, 2)}</TableCell>
                                                    <TableCell align="center">
                                                        {row.sFileLink && renderCellFileCustomTable(nNo, row, handleClickFile)}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            ) : (
                                <TableRow key={"r-no-data"}>
                                    <TableCell align="center" colSpan={isView ? 4 : 6}>
                                        ไม่พบข้อมูล
                                    </TableCell>
                                </TableRow>
                            )}
                        </Table>
                    </TableContainer>
                    <CustomTablePagination
                        dataTable={dataTable}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        page={page}
                        setPage={setPage}
                        colSpan={isView ? 4 : 6}
                        onDelete={handleDelete}
                        isShowDelete={selected.length > 0}
                        OptionRowsPerPage={[5, 10, 25, 50, 100]}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    {
                        isRent ?
                            <TableTotal sTitle={"ยอดรวมค่าเช่า"} nValue={objValue.nAmountRent} />
                            :
                            <TableTotal sTitle={"ยอดรวมเงินบริจาค"} nValue={objValue.nAmountDonate} />
                    }
                </Grid>
            </Grid>
            <RenderCellFile
                isOpen={isOpenFile}
                setIsOpen={setisOpenFile}
                arrFile={arrFile}
            />
        </>

    );
};

export default TablePaymentAdd;

